import { render, staticRenderFns } from "./tab-finance.html?vue&type=template&id=951d4bb4&scoped=true&external"
import script from "./tab-finance.js?vue&type=script&lang=js&external"
export * from "./tab-finance.js?vue&type=script&lang=js&external"
import style0 from "./tab-finance.scss?vue&type=style&index=0&id=951d4bb4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951d4bb4",
  null
  
)

export default component.exports